const state = {
  user: {
    name: null
  },
  token: null,
  refresh_token: null,
  // admin-only UI preview flag: when set to 'non-admin', components that gate
  // on user.role === 'admin' should gate on effectiveRole instead so the admin
  // sees what a non-admin sees without logging out. persisted in localStorage
  // so the preference survives page reloads.
  view_as: (() => {
    try { return localStorage.getItem('view_as') || null } catch (_) { return null }
  })()
}

const mutations = {
  set_user_data(state, user){
    state.user = user
  },
  set_view_as(state, value){
    state.view_as = value || null
    try {
      if (value) localStorage.setItem('view_as', value)
      else localStorage.removeItem('view_as')
    } catch (_) {}
  },
}

export default {
  namespaced: true,
  state,
  mutations
}
